export default __webpack_public_path__ + "static/media/cnc-laser-cutting-of-metal-modern-industrial-technology-SBV-314898666-HD.255ea9e5.mp4";